/**
 * Admin-Zentrale (Integrationen + Kundenportal) — Client für /api/admin-settings.
 * Schlüssel verlassen den Browser nur einmal beim Speichern; zurück kommt
 * ausschließlich "gesetzt / ••••1234".
 */
import { getAccessToken } from '@/api/adapters/SupabaseAdapter';

async function call(action, payload = {}) {
  const token = await getAccessToken();
  const r = await fetch('/api/admin-settings', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ action, ...payload }),
  });
  const data = await r.json().catch(() => ({}));
  if (r.status === 404 && !data.error) {
    // Lokal (npx vite) laufen keine Vercel-Funktionen
    const err = new Error('Server-Funktion nicht erreichbar. Lokal bitte „npx vercel dev“ nutzen oder DEV_API_PROXY setzen — online erst nach dem Deploy verfügbar.');
    err.code = 'API_NICHT_ERREICHBAR';
    throw err;
  }
  if (!r.ok) throw new Error(data.error || `Fehler (HTTP ${r.status})`);
  return data;
}

export const listIntegrations = () => call('integrationen.liste');
/** @param {{ provider: string, enabled: boolean, mode: string, config: object, secrets: Record<string, string|null> }} p */
export const saveIntegration = (p) => call('integration.speichern', p);
export const testIntegration = (provider) => call('integration.testen', { provider });

export const getPortalSettings = () => call('portal.einstellungen');
export const savePortalSettings = (settings) => call('portal.einstellungen.speichern', { settings });
export const listPortalUsers = () => call('portal.benutzer').then((d) => d.items || []);
export const invitePortalUser = ({ leadId, email }) => call('portal.einladen', { leadId, email });
export const createPortalLink = (portalUserId) => call('portal.link', { portalUserId });
export const setPortalUserBlocked = (portalUserId, gesperrt) => call('portal.sperren', { portalUserId, gesperrt });
export const removePortalUser = (portalUserId) => call('portal.entfernen', { portalUserId });
